<template>
  <div id="app">
    <redirector />
  </div>
</template>

<script>
import Redirector from './components/Redirector'

export default {
  name: 'App',
  components: {
    Redirector
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
